import * as React from "react";
import {
    ExpansionPanel,
    ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import DashboardCards from "./DashboardCards";

const QuickView = React.memo(({ period, title = "Quick View" }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleAction = React.useCallback((event) => {
        setExpanded(!event.expanded);
    }, []);

    return (
        <ExpansionPanel
            title={title}
            expandIcon="fa fa-plus"
            collapseIcon="fa fa-minus"
            expanded={expanded}
            onAction={handleAction}
        >
            {expanded && (
                <ExpansionPanelContent>
                    <DashboardCards period={period} />
                </ExpansionPanelContent>
            )}
        </ExpansionPanel>
    );
});

QuickView.displayName = "QuickView";

export default QuickView;